import { render, staticRenderFns } from "./LocationSelector.vue?vue&type=template&id=4813bbdc&"
import script from "./LocationSelector.vue?vue&type=script&lang=js&"
export * from "./LocationSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports